import { render, staticRenderFns } from "./applink.vue?vue&type=template&id=399b9684&scoped=true&"
import script from "./applink.vue?vue&type=script&lang=js&"
export * from "./applink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b9684",
  null
  
)

export default component.exports